import { parseTeamDetailsAPIData, parseTeamPlayersAPIData, parseTeamStatsAPI, parseTeamTransferAPIData } from "../../utils/parseFootballAPIResponse";
import { getSeason } from "../../utils/helper";
import * as action_type from "./../actions/livescore/action_types";
const initialState = {
  poolRankingList: [],
  liveScore: [],
  currentTimerTime: "00:00",
  minutes: 0,
  seconds: 0,
  teamStats: [],
  teamTransfers: [],
  teamPlayers: [],
  playerDetails: [],
  teamDetails: [],
  currentTeamId: null,
};
const LivescoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case action_type.POOL_RANKING_SUCCESS: {
      const raw = action.data && action.data.response && action.data.response[0] && action.data.response[0].league && action.data.response[0].league.standings;
      let poolRankingList = [];
      if (Array.isArray(raw) && raw.length > 0) {
        // API may return flat array (football-data.org) or array-of-groups (RapidAPI). Normalize to array-of-groups.
        poolRankingList = Array.isArray(raw[0]) ? raw : [ raw ];
      }
      return Object.assign({}, state, { poolRankingList });
    }
    case action_type.GET_LIVE_SCORE_SUCCESS:
      // let LiveScoreData=action.data.api.fixtures.filter(rowData=>(rowData.league_id===action.league_id));
      // console.log("LiveScoreData",LiveScoreData)
      return Object.assign({}, state, {
        liveScore: action.data,
      });
    case action_type.SET_TIMER_TIME:
      return Object.assign({}, state, {
        currentTimerTime: action.data.currentTimerTime,
        minutes: action.data.minutes,
        seconds: action.data.seconds,
      });
    case action_type.GET_TEAM_DETAILS_FETCH:
      return Object.assign({}, state, {
        currentTeamId: action.team_id,
        teamTransfers: [],
        teamPlayers: [],
        teamStats: [],
      });
    case action_type.GET_TEAM_STATS_SUCCESS:
      if (action.team_id != null && action.team_id !== state.currentTeamId) return state;
      return Object.assign({}, state, {
        teamStats: parseTeamStatsAPI(action.data.response)
      });
    case action_type.GET_TEAM_TRANSFERS_SUCCESS:
      if (action.team_id != null && action.team_id !== state.currentTeamId) return state;
      return Object.assign({}, state, {
        teamTransfers: parseTeamTransferAPIData(action.data.response, getSeason())
      });
    case action_type.GET_TEAM_PLAYERS_SUCCESS:
      if (action.team_id != null && action.team_id !== state.currentTeamId) return state;
      return Object.assign({}, state, {
        teamPlayers: parseTeamPlayersAPIData(action.data.response, action.leagueId)
      });
    case action_type.GET_PLAYER_BY_ID_SUCCESS:
      const rawPlayers = action.data.api?.players || action.data.response || [];
      return Object.assign({}, state, {
        playerDetails: parseTeamPlayersAPIData(Array.isArray(rawPlayers) ? rawPlayers : []),
      });
    case action_type.GET_TEAM_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        teamDetails: parseTeamDetailsAPIData(action.data.response[0])
      });
    default:
      return state;
  }
};

export default LivescoreReducer;